import * as React from "react";

import { createSvgIcon } from "@mui/material";

export const LockedIcon = createSvgIcon(
  <svg viewBox={"0 0 37 37"} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.75 12.333h-1.542V9.25a7.711 7.711 0 0 0-7.709-7.708 7.711 7.711 0 0 0-7.708 7.708v3.083H9.249a3.092 3.092 0 0 0-3.083 3.084v15.416a3.092 3.092 0 0 0 3.083 3.084h18.5a3.092 3.092 0 0 0 3.084-3.084V15.417a3.092 3.092 0 0 0-3.084-3.084ZM18.5 26.208a3.092 3.092 0 0 1-3.084-3.083 3.092 3.092 0 0 1 3.083-3.083 3.092 3.092 0 0 1 3.084 3.083 3.092 3.092 0 0 1-3.084 3.083Zm4.779-13.875H13.72V9.25a4.783 4.783 0 0 1 4.78-4.78 4.783 4.783 0 0 1 4.779 4.78v3.083Z"
      fill="#BBB"
    />
  </svg>,
  "Locked Icon"
);
